export default "__VITE_ASSET__ad855608__"